import { WhatsAppOfficialAtendimento } from "./whatsapp-oficial-atendimento";
import { WhatsAppOfficialEtapa } from "./whatsapp-oficial-etapa";

export class WhatsAppOfficialKanban {
  public etapas: WhatsAppOfficialEtapa[];
  public atendimentos: WhatsAppOfficialAtendimento[];

  constructor() {
    this.etapas = [];
    this.atendimentos = [];
  }
}
